import brandHoverView from "./views/brandHoverView.js";
import faqView from "./views/questionsView.js";
import changeSliders from "./views/sliderView.js";
import autoCalendarDate from "./views/autoCalendarDate.js";
import searchView from "./views/searchView.js";
import * as model from "./model.js";
import morePriceBtn from "./views/morePriceBtn.js";

// ++++++++++++++++++++++++++++++++  feature slider  +++++++++++++++++++++++++++++
const controlSlider = function (goToSlide) {
  changeSliders.changeActiveCircle(goToSlide);

  clearInterval(changeSliders.interval);
};

const controlSearchLoad = async function (userInput) {
  try {
    // spinner
    searchView.renderSpinner();
    // load search results
    await model.loadSearchResults(userInput);
    // render search results
    setTimeout(() => {
      // console.log(model.state.searcResults);
      searchView.render(model.state.searcResults);
    }, 2000);
  } catch (err) {
    searchView.renderError();
  }
};

const init = function () {
  // manuall slide changer
  changeSliders.addHandlerManualSlider(controlSlider);
  // Auto slide changer
  changeSliders.addHandlerAutoSlider();
  // search
  searchView.addHandlerKeyPress(controlSearchLoad);
};

init();
